import React, { useEffect, useState } from 'react';
import Preloader from '../Preloder/Preloader';
import axios from 'axios';

const Examcertificate = () => {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const baseUrl = `${process.env.REACT_APP_API}/uploads/examcertificates/`;

  useEffect(() => {
    const fetchCertificates = async () => {
      const id = localStorage.getItem('UserId');

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/questions/getexamcertificate/${id}`
        );
        const certs = response.data.certificates || [];
        setCertificates(certs);
      } catch (err) {
        console.error(err);
        setError('Failed to fetch certificates');
      } finally {
        setLoading(false);
      }
    };

    fetchCertificates();
  }, []);

  if (loading) return <Preloader />;
  if (error) return <div style={{ color: 'red', margin: '20px' }}>{error}</div>;
  if (certificates.length === 0) return <div style={{ margin: '20px' }}>No certificates found.</div>;

  return (
    <div style={{ padding: '20px' }}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          justifyContent: 'center',
        }}
      >
        {certificates.map((certificate, index) => {
          const certUrl = `${baseUrl}${certificate.certificate}`;
          const isPdf = certificate.certificate?.endsWith('.pdf');

          return (
            <div
              key={index}
              style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '15px',
                width: '300px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <div>
                {/* <h3 style={{ fontSize: '18px', marginBottom: '10px' }}>
                  Certificate #{certificate.id}
                </h3>

                <p><strong>Student ID:</strong> {certificate.studenttableid}</p> */}

                {certificate.amount && (
                  <p><strong>Exam Price:</strong> ₹{certificate.amount}</p>
                )}

                <p><strong>Issued On:</strong> {new Date(certificate.created_at).toLocaleDateString()}</p>

                {certificate.certificate ? (
                  <>
                    {isPdf ? (
                      <div
                        style={{
                          height: '200px',
                          marginBottom: '10px',
                          overflow: 'auto',
                          border: '1px solid #eee',
                        }}
                      >
                        <iframe
                          src={certUrl}
                          title={`Certificate-${certificate.id}`}
                          width="100%"
                          height="100%"
                        ></iframe>
                      </div>
                    ) : (
                      <img
                        src={certUrl}
                        alt={`Certificate-${certificate.id}`}
                        style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
                      />
                    )}
                  </>
                ) : (
                  <p style={{ color: 'gray' }}>No certificate file available.</p>
                )}
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 'auto' }}>
                <a
                  href={certUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    padding: '8px 12px',
                    backgroundColor: '#17a2b8',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '5px',
                    fontSize: '14px',
                  }}
                >
                  View
                </a>
                <a
                  href={certUrl}
                  download
                  style={{
                    padding: '8px 12px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '5px',
                    fontSize: '14px',
                  }}
                >
                  Download
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Examcertificate;
